/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.WalkinManager.AddToWaitlist {

    import ScanOriginEnum = Meevo.Model.ScanOriginEnum;
    import EmployeeGenderSearchEnum = Meevo.Model.EmployeeGenderSearchEnum;
    import IWalkinAppointmentAddOn = Meevo.Model.IWalkinAppointmentAddOn;

    export interface IScanForOpeningsService {
        scan: Function;

        getGenderInfo(gender: string): EmployeeGenderSearchEnum;

        prepareServicesForScan(services: IWLSelectedService[], clientID: string): IScanService[];
    }

    export interface IAddonService extends IWalkinAppointmentAddOn {
        extendedByStepId: string;
        extendedByStepMinutes: number;
        isRequired: boolean;
        price: number;
        serviceDisplayName: string;
        serviceShortcut: string;
    }

    export interface IScanService {
        serviceId: string;
        clientId: string;
        employeeId?: string;
        genderPreferenceEnum?: EmployeeGenderSearchEnum;
        employeePreference?: string;
        addOnServiceIds?: Array<string | Guid>;
        addOnServices?: IAddonService[];
        serviceDisplayName?: string;
        employeeLabel?: string;
    }

    export interface IScanRequestData {
        scanServices: Array<IScanService>,
        scanOrigin: ScanOriginEnum,
        appointmentServiceIgnoreList: Array<string>,
        startTime?: string,
        endTime?: string,
        startDate?: string,
        endDate?: string
    }

    interface IPrepareTime {
        startTime: string,
        endTime: string
    }

    export interface IServiceOpening {
        date: string,
        startTime: string,
        endTime: string,
        serviceId: Guid,
        employeeId: Guid,
        clientId: Guid,
        resourcePriority: number,
        resourceCapacity: number,
        serviceName: string,
        serviceBasePrice: number,
        employeeName: string,
        employeeGender: Meevo.Model.GenderEnum,
        employeePrice: number,
        employeePriceLevel: Meevo.Model.PriceLevelEnum,
        nonRequest: boolean,
        genderPreference: EmployeeGenderSearchEnum,
        waitTime?: number
    }

    export interface IOpeningContainer {
      serviceOpenings: Array<IServiceOpening>
    }

    export class ScanForOpeningsService implements IScanForOpeningsService {

        constructor(
            protected $q: ng.IQService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService
        ) {

        }

        public getGenderInfo (gender: string): EmployeeGenderSearchEnum {
            let genderValue: EmployeeGenderSearchEnum;

            switch (gender) {
                case 'Male Only':
                    genderValue = EmployeeGenderSearchEnum.AnyMale;
                    break;
                case 'Female Only':
                    genderValue = EmployeeGenderSearchEnum.AnyFemale;
                    break;
                case 'First Available':
                    genderValue = EmployeeGenderSearchEnum.AnyEmployee;
                    break;
                default:
                    genderValue = EmployeeGenderSearchEnum.SpecificEmployee;
                    break;
            }

            return genderValue;
        }

        prepareServicesForScan(services: IWLSelectedService[], clientID: string): IScanService[] {
            return services.map((service) => ({
                serviceId: service.service.id,
                clientId: clientID,
                employeeId: service.employee ? service.employee.id : null,
                genderPreferenceEnum: service.employeePreference,
                addOnServiceIds: service.addOns.map((addOn: any) => addOn.addOnServiceId)
            }));
        }

        prepareRequestData(scanService: Array<IScanService>, gender: string, employeeId: string, serviceIgnore?: string): IScanRequestData {
            let requestData: IScanRequestData = <IScanRequestData>({}),
                time = ScanForOpeningsService.prepareTime();

            requestData.scanOrigin = ScanOriginEnum.WalkinManager;
            requestData.appointmentServiceIgnoreList = serviceIgnore ? new Array(serviceIgnore) : [];
            requestData.startTime = time.startTime;
            requestData.endTime = time.endTime;

            //scanService.genderPreferenceEnum = this.getGenderInfo(gender);

            //if (employeeId) {
            //    scanService.employeeId = employeeId;
            //}

            //requestData.scanServices = [scanService];
            requestData.scanServices = scanService;

            return requestData;
        }

        static prepareTime(): IPrepareTime {
            let time = {
                startTime: '',
                endTime: ''
            }, today = new Date(),
                date,
                month = String(today.getMonth() + 1),
                hours = today.getHours(),
                numMinutes = today.getMinutes(),
                minutes = '00';

            month = ('0' + month).slice(-2);
            date = `${today.getFullYear()}-${month}-${('0' + today.getDate()).slice(-2)}T`;

            if (numMinutes < 15) {
                minutes = '15';
            } else if (numMinutes < 30) {
                minutes = '30';
            } else if (numMinutes < 45) {
                minutes = '45';
            } else {
                minutes = '00';
                hours += 1;
            }

            if (hours === 24) {
                hours = 23;
                minutes = String(numMinutes);
            }

            time.startTime = `${date}${('0' + hours).slice(-2)}:${minutes}:00`;
            time.endTime = `${date}23:59:59`;

            return time;
        }

        static processOpenings(openings: Array<IServiceOpening>): Array<IServiceOpening> {
          //let opening = openings[0]['serviceOpenings'][0];

          //opening.waitTime = Math.floor(opening.waitTime);

          //return opening;
            var opening = openings[0]['serviceOpenings'];
            _.forEach(opening.serviceOpenings, (o: IServiceOpening) => {
                o.waitTime = Math.floor(o.waitTime);
                o.waitTime = Math.max(0, o.waitTime);
            });
            return opening;
        }

        scan(scanService: Array<IScanService>, gender: string, employeeId: string, serviceIgnore?: string): ng.IPromise<any> {
            let uri = `/${this.appSettings.API_ROOT}/WalkinAppointment/Opening/List`,
                requestData: IScanRequestData = this.prepareRequestData(scanService, gender, employeeId, serviceIgnore),
                deferred = this.$q.defer();

            this.dataService.customMethodData(uri, 'POST', requestData)
                .then((response) => {
                    let {data} = response;

                    if (response.status === 409) {
                        deferred.reject(data.responseStatus.message);
                    } else {
                      if (data.length > 0) {
                          deferred.resolve(ScanForOpeningsService.processOpenings(data));
                      } else {
                          deferred.reject();
                      }
                    }
                })
                .catch(() => {
                    deferred.reject();
                });

            return deferred.promise;
        }

        static factory(): Function {
            let svc = (
                $q: ng.IQService,
                appSettings: Meevo.Components.Common.IAppSettings,
                dataService: Meevo.Components.BaseClasses.IDataService
            ) => {
                return new ScanForOpeningsService($q, appSettings, dataService);
            };

            svc.$inject = [
                '$q',
                'meevo.AppSettings',
                'meevo.components.common.DataService'
            ];
            return svc;
        }
    }

    angular.module("meevo.plugins.walkinManager")
        .service('meevo.plugins.walkinManager.addToWaitlist.ScanForOpeningsService', ScanForOpeningsService.factory());
}
